var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "232px",
    height: "201px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 76.8333,-0.5 154.167,-0.5 231.5,-0.5C 231.5,66.5 231.5,133.5 231.5,200.5C 154.167,200.5 76.8333,200.5 -0.5,200.5C -0.5,133.5 -0.5,66.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf5e3",
    d: "M 166.5,161.5 C 175.428,149.69 174.428,138.857 163.5,129C 157.517,125.517 151.683,125.684 146,129.5C 147.359,127.711 148.526,125.545 149.5,123C 149.241,121.739 148.574,120.739 147.5,120C 129.17,119.5 110.836,119.333 92.5,119.5C 89.5,119.5 86.5,119.5 83.5,119.5C 81.1432,119.337 78.8098,119.503 76.5,120C 73.6822,122.901 74.0155,125.401 77.5,127.5C 78.4988,138.814 78.8322,150.147 78.5,161.5C 56.2537,144.761 34.4203,127.428 13,109.5C -2.09952,93.0511 -3.43285,75.3844 9,56.5C 20.7656,36.0684 36.5989,19.5684 56.5,7C 74.0298,1.01978 91.3631,1.68645 108.5,9C 121.963,16.1414 135.63,22.8081 149.5,29C 167.188,31.4692 184.854,34.1359 202.5,37C 214.822,42.3513 221.322,51.8513 222,65.5C 222.738,81.6051 224.405,97.6051 227,113.5C 228.085,123.643 227.418,133.643 225,143.5C 221.17,150.31 215.337,154.477 207.5,156C 193.887,158.316 180.22,160.149 166.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f09d91",
    d: "M 123.5,31.5 C 135.964,32.9819 146.464,38.3152 155,47.5C 158.332,55.8453 158.332,64.1786 155,72.5C 152.382,77.1163 148.549,80.283 143.5,82C 137.689,82.8006 132.022,84.1339 126.5,86C 119.614,88.8879 115.781,94.0546 115,101.5C 114.667,104.833 114.333,108.167 114,111.5C 103.72,103.231 95.7198,93.2309 90,81.5C 87.6287,73.0768 90.462,67.2435 98.5,64C 105.517,62.3325 112.517,60.6658 119.5,59C 129.39,56.0183 131.89,49.8516 127,40.5C 124.566,37.6911 123.4,34.6911 123.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#33608c",
    d: "M 83.5,119.5 C 83.5,122.167 83.5,124.833 83.5,127.5C 82.5,127.5 81.5,127.5 80.5,127.5C 80.1698,146.341 80.5031,165.007 81.5,183.5C 81.5569,184.609 81.8902,185.609 82.5,186.5C 81.8333,186.5 81.1667,186.5 80.5,186.5C 80.2172,185.711 79.7172,185.044 79,184.5C 78.5003,176.841 78.3336,169.174 78.5,161.5C 78.8322,150.147 78.4988,138.814 77.5,127.5C 74.0155,125.401 73.6822,122.901 76.5,120C 78.8098,119.503 81.1432,119.337 83.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7494b2",
    d: "M 83.5,119.5 C 86.5,119.5 89.5,119.5 92.5,119.5C 92.5,122.167 92.5,124.833 92.5,127.5C 89.5,127.5 86.5,127.5 83.5,127.5C 83.5,124.833 83.5,122.167 83.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#275887",
    d: "M 92.5,119.5 C 110.836,119.333 129.17,119.5 147.5,120C 148.574,120.739 149.241,121.739 149.5,123C 148.526,125.545 147.359,127.711 146,129.5C 151.683,125.684 157.517,125.517 163.5,129C 174.428,138.857 175.428,149.69 166.5,161.5C 157.672,170.495 149.005,179.662 140.5,189C 134.175,189.5 127.842,189.666 121.5,189.5C 121.167,189.5 120.833,189.5 120.5,189.5C 126.167,188.833 131.833,188.167 137.5,187.5C 140.703,187.318 142.536,185.652 143,182.5C 152.748,174.754 161.081,165.754 168,155.5C 173.156,143.634 169.99,134.8 158.5,129C 152.598,127.624 147.598,129.124 143.5,133.5C 143.5,131.5 143.5,129.5 143.5,127.5C 126.5,127.5 109.5,127.5 92.5,127.5C 92.5,124.833 92.5,122.167 92.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afc0d0",
    d: "M 83.5,127.5 C 86.5,127.5 89.5,127.5 92.5,127.5C 109.5,127.5 126.5,127.5 143.5,127.5C 143.5,129.5 143.5,131.5 143.5,133.5C 142.549,132.081 142.216,130.415 142.5,128.5C 122.167,128.5 101.833,128.5 81.5,128.5C 81.5,146.833 81.5,165.167 81.5,183.5C 80.5031,165.007 80.1698,146.341 80.5,127.5C 81.5,127.5 82.5,127.5 83.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f6f7",
    d: "M 143.5,133.5 C 147.598,129.124 152.598,127.624 158.5,129C 169.99,134.8 173.156,143.634 168,155.5C 161.081,165.754 152.748,174.754 143,182.5C 142.536,185.652 140.703,187.318 137.5,187.5C 131.167,187.5 124.833,187.5 118.5,187.5C 106.55,186.541 94.5502,186.207 82.5,186.5C 81.8902,185.609 81.5569,184.609 81.5,183.5C 81.5,165.167 81.5,146.833 81.5,128.5C 101.833,128.5 122.167,128.5 142.5,128.5C 142.216,130.415 142.549,132.081 143.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#426a92",
    d: "M 144.5,172.5 C 143.506,163.014 143.173,153.348 143.5,143.5C 144.028,142.279 144.695,141.113 145.5,140C 148.128,137.534 151.128,135.701 154.5,134.5C 160.72,135.88 163.72,139.713 163.5,146C 163.733,149.459 162.899,152.626 161,155.5C 155.969,161.697 150.469,167.364 144.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf3e2",
    d: "M 153.5,136.5 C 156.099,136.549 158.266,137.549 160,139.5C 161.504,143.039 161.837,146.705 161,150.5C 156.953,157.239 151.953,163.239 146,168.5C 145.333,160.167 145.333,151.833 146,143.5C 148.396,140.933 150.896,138.6 153.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ca6be",
    d: "M 143.5,143.5 C 143.173,153.348 143.506,163.014 144.5,172.5C 144.44,173.043 144.107,173.376 143.5,173.5C 142.177,163.341 142.177,153.341 143.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7d27b",
    d: "M 80.5,186.5 C 81.1667,186.5 81.8333,186.5 82.5,186.5C 94.5502,186.207 106.55,186.541 118.5,187.5C 118.833,188.5 119.5,189.167 120.5,189.5C 120.833,189.5 121.167,189.5 121.5,189.5C 122.303,190.423 122.47,191.423 122,192.5C 120.082,193.542 118.249,194.708 116.5,196C 92.8333,196.667 69.1667,196.667 45.5,196C 42.8333,193 42.8333,190 45.5,187C 57.1619,186.5 68.8286,186.333 80.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7292ad",
    d: "M 118.5,187.5 C 124.833,187.5 131.167,187.5 137.5,187.5C 131.833,188.167 126.167,188.833 120.5,189.5C 119.5,189.167 118.833,188.5 118.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f5f0",
    d: "M 46.5,188.5 C 47.5,188.5 48.5,188.5 49.5,188.5C 49.5,190.5 49.5,192.5 49.5,194.5C 45.5564,194.116 44.5564,192.116 46.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f4ef",
    d: "M 51.5,188.5 C 71.8443,188.167 92.1776,188.5 112.5,189.5C 102.333,189.833 92.1667,190.167 82,190.5C 71.4773,190.499 61.3107,189.832 51.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f8f9",
    d: "M 51.5,192.5 C 71.8443,192.167 92.1776,192.5 112.5,193.5C 102.333,193.833 92.1667,194.167 82,194.5C 71.4773,194.499 61.3107,193.832 51.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f3ec",
    d: "M 114.5,188.5 C 119.516,190.18 119.683,192.18 115,194.5C 115.793,192.5 115.626,190.5 114.5,188.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState05);
export default __webpack_public_path__ + "static/media/emptyState05.8082f4171407e7a58c2fe10642b2bdd8.svg";
export { ForwardRef as ReactComponent };